<template>
  <Card class="overflow-hidden h-max w-full">
    <template #header>
      <img
        :src="thumbnail || emptyImg"
        @error="imgDefaultError"
        class="object-cover"
        style="height: 13rem"
        loading="lazy"
      />
    </template>
    <template #title>
      <p class="break-words">
        {{
          title ||
          $t("labels.generic", { pt: "Nome do curso", en: "Course name" })
        }}
      </p>
    </template>
    <template #subtitle>
      <p class="text-gray-400 break-words">
        {{
          description ||
          $t("labels.generic", {
            pt: "Resumo do curso...",
            en: "Course description...",
          })
        }}
      </p>
    </template>
    <template #content>
      <div
        :class="`overflow-clip hover:overflow-auto scroll-style w-full ${
          categories.length !== 0 ? 'h-12' : 'h-full'
        }`"
      >
        <div class="flex gap-1 p-1">
          <div v-for="(categorie, i) in categories" :key="i">
            <Tag
              class="w-max select-none btn-primary"
              :value="categorie?.name"
              tabindex="0"
            ></Tag>
          </div>
        </div>
      </div>
    </template>
  </Card>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
export default defineComponent({
  name: "cardView",
  data() {
    return {
      emptyImg:
        "https://video-thumb.s3.sa-east-1.amazonaws.com/65197bdbplaceholder.png" as string,
    };
  },
  props: {
    thumbnail: {
      type: String as PropType<string>,
      default: null,
    },
    title: {
      type: String as PropType<string>,
      default: "",
    },
    description: {
      type: String as PropType<string>,
      default: "",
    },
    categories: {
      type: Array as PropType<any>,
      default: [],
    },
  },
  methods: {
    imgDefaultError(e: any): void {
      e.target.src =
        "https://video-thumb.s3.sa-east-1.amazonaws.com/65197bdbplaceholder.png";
    },
  },
});
</script>
